import TokenManager from "../helpers/TokenManager";
import store from "../store";
import VueGatesPlugin from '../plugins/vue-gates';


export default function AuthMiddleware({to,next, from}) {

    // console.log( to, "to to to");
    // const tokenManager = new TokenManager();
    let token = TokenManager.getToken();
    // // // console.log("from",from);
    if(token !== null && store.state.loggedIn && from.path != "/login" && !to.meta.loadMe){
        // console.log("ENTRA EN PRIMER IF")
        if(to.path == '/login' || to.path == '/dashboard'){
            // // console.log("aka")
            next('/');
        }
        console.log("auhasldiuygaso")
        store.state.layout = 'dashboard'
        document.title = to.meta.title
        next();
    }else{
        // console.log("ENTRA EN SEGUNDO IF")
        if(token !== null){
            store.$api.auth.me()
            .then((response) => {
                
                if(!response.data){
                    store.state.loggedIn = false
                }
                else{
                // //    // console.log(response, 'ME');
                    store.state.loggedIn = true
                    store.state.loggedUsername = response.data.employee.name;
                    store.state.userData = response.data;
                    // console.log(response.data);
                    
                    //avoid an employee enter to other route if its has an temporary password
                    if("employee_site" in store.state.userData.role.permissions){
                        if(store.state.userData.role.permissions.employee_site.show){
                            if(store.state.userData.has_temp_password){
                                next('/m/reset-password');
                            }
                        }
                    }

                    if("integradora_user" in store.state.userData.role.permissions){
                        if(store.state.userData.role.permissions.integradora_user.show){
                            if(store.state.userData.has_temp_password){
                                next('/e/reset-password');
                            }
                        }
                    }
                    
                    store.state.company = response.data?.company?.id??"";
                    VueGatesPlugin.init();
                    
                    if(!store.$socket.connected){
                        store.$socket.auth.token = TokenManager.getToken();
                        store.$socket.connect();
                        // // console.log(store.$socket, "qui");
                    }
                }
                
                if(store.state.loggedIn){
                    if(to.meta.auth){
                        store.state.layout = to.meta.loadMe ? to.meta.layout : 'dashboard'
                        document.title = to.meta.title;
                        const redirect = sessionStorage.getItem('rrhh_redirect');
                        if(redirect != null){
                            sessionStorage.removeItem('rrhh_redirect');
                            next(redirect);
                        }else{
                            next();
                        }
                    }else{
                        store.state.layout = to.meta.loadMe ? to.meta.layout : 'dashboard'
                        const redirect = sessionStorage.getItem('rrhh_redirect');
                        if(redirect != null){
                            sessionStorage.removeItem('rrhh_redirect');
                            next(redirect);
                        }else{
                            next('/');
                        }
                    }
                }else{
                    if(to.meta.auth){
                        store.state.layout = 'login'
                        next('login');
                    }else{
                        store.state.layout = 'login'
                        next()
                    }
                }

               
            })
            .catch(() => {
                // // console.log(error, to)
                // TokenManager.removeToken();
                // store.state.layout = 'login'
                // next('login')
                // store.$socket.close();
                // return;
                externalCall({to,next,from});
           
            })
        }else{
            //redirect part
            if(to.path != "/login")
                sessionStorage.setItem('rrhh_redirect', to.path)
            if(to.meta.auth){
                store.state.layout = 'login'
                next('login')
            }else{
                store.state.layout = 'login'
                next()
            }
        }
    }
}

function externalCall({to,next, from}) {
    // // //console.log( to);
    // const tokenManager = new TokenManager();
    let token = TokenManager.getToken();
    // // // console.log("from",from);
    if(token !== null && store.state.loggedIn && from.path != "/login"){
        if(to.path == '/login' || to.path == '/dashboard'){
            // // console.log("aka")
            next('/');
        }
        store.state.layout = 'dashboard'
        document.title = to.meta.title
        next();
    }else{
        if(token !== null){
            store.$api.auth.externalMe()
            .then((response) => {
                
                if(!response.data){
                    store.state.loggedIn = false
                }
                else{
                // //    // console.log(response, 'ME');
                    store.state.loggedIn = true
                    store.state.loggedUsername = response.data.email;
                    store.state.userData = response.data;
                    // console.log(response.data);

                    store.state.userData.role = {name: "integradora", permissions: {integradora_user: {show:true}} }
                    
                    //avoid an employee enter to other route if its has an temporary password
                    if("employee_site" in store.state.userData.role.permissions){
                        if(store.state.userData.role.permissions.employee_site.show){
                            if(store.state.userData.has_temp_password){
                                next('/m/reset-password');
                            }
                        }
                    }
                    
                    store.state.externalBusiness = [];
                    store.state.company = response.data?.company?.id??"";
                    VueGatesPlugin.init();


                    if("integradora_user" in store.state.userData.role.permissions){
                        if(store.state.userData.role.permissions.integradora_user.show){
                            if(store.state.userData.has_temp_password){
                                next('/e/reset-password');
                            }
                        }
                    }
                    
                    
                    if(!store.$socket.connected){
                        store.$socket.auth.token = TokenManager.getToken();
                        store.$socket.connect();
                        // // console.log(store.$socket, "qui");
                    }
                }
                
                if(store.state.loggedIn){
                    if(to.meta.auth){
                        store.state.layout = 'dashboard'
                        document.title = to.meta.title
                        next();
                    }else{
                        store.state.layout = 'dashboard'
                        next('/');
                    }
                }else{
                    if(to.meta.auth){
                        store.state.layout = 'login'
                        next('login');
                    }else{
                        store.state.layout = 'login'
                        next()
                    }
                }

               
            })
            .catch((error) => {
                if(to.path != "/login")
                    sessionStorage.setItem('rrhh_redirect', to.path)
                console.log(error)
                TokenManager.removeToken();
                store.state.layout = 'login'
                next('login')
                store.$socket.close();
                return;
           
            })
        }else{
            if(to.path != "/login")
                sessionStorage.setItem('rrhh_redirect', to.path)
            if(to.meta.auth){
                store.state.layout = 'login'
                next('login')
            }else{
                store.state.layout = 'login'
                next()
            }
        }
    }
}